import { NeoModel, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class DailyLogReportReportCriteria extends ValueObject  
{
    public Criteria: Date = new Date();
}